import React, { forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AppBar, UserMenu, MenuItemLink, useTranslate } from 'react-admin';
import { useHistory } from 'react-router-dom'; // ✅ Import useHistory for redirection
import SettingsIcon from '@material-ui/icons/Settings';
import { makeStyles } from '@material-ui/core/styles';
import PersonIcon from '@material-ui/icons/Person';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import Brightness4Icon from '@material-ui/icons/Brightness4';
import Brightness7Icon from '@material-ui/icons/Brightness7';
import VerticalSplitIcon from '@material-ui/icons/VerticalSplit';
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit';
import jwt_decode from 'jwt-decode';
import HomeIcon from '@material-ui/icons/Home'; // ✅ Import Home icon
import { Drawer, Typography, Toolbar, IconButton, Button, Menu, MenuItem,Divider, Tooltip, useMediaQuery  } from '@material-ui/core';
import { changeTheme, changeMenuLayout } from '../configuration/actions';
import Logo from './Logo';

const {REACT_APP_VERSION} = process.env;



const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    about:{
        fontStyle: 'italic'
    }
});

const ConfigurationMenu = forwardRef((props, ref) => {
    const translate = useTranslate();
    return (
        <MenuItemLink
            ref={ref}
            to="/configuration"
            primaryText={translate('pos.configuration')}
            leftIcon={<SettingsIcon />}
            onClick={props.onClick}
        />
    );
});

const Profile =()=>{

    return (
        <MenuItemLink
            to=""
            primaryText={((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).full_name : null }
            leftIcon={<PersonIcon />}
        />
    )
}

const Version = ()=>{
    const classes = useStyles();
    return (
        <MenuItemLink
            to=""
            primaryText={`HemDonER ver ${REACT_APP_VERSION}`}
            leftIcon={<InfoIcon />}
            className={classes.about}
        />
    )
}

const CustomUserMenu = props => (
    <UserMenu {...props}>
        <ConfigurationMenu />
        <Profile />
        {REACT_APP_VERSION && <Version />}
    </UserMenu>
);

const ThemeToggle = () => {
    const theme = useSelector(state => state.theme);
    const dispatch = useDispatch();
    const isDark = theme === 'dark';
    return (
        <Tooltip title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}>
            <IconButton
                color="inherit"
                aria-label="toggle light/dark theme"
                onClick={() => dispatch(changeTheme(isDark ? 'light' : 'dark'))}
            >
                {isDark ? <Brightness7Icon /> : <Brightness4Icon />}
            </IconButton>
        </Tooltip>
    );
};



/**
 * Switches the navigation between the sidebar and a horizontal bar.
 * The choice is remembered in localStorage by menuLayoutReducer.
 * Hidden on small screens, where the top menu falls back to the sidebar.
 */
const MenuLayoutToggle = () => {
    const layout = useSelector(state => state.menuLayout);
    const dispatch = useDispatch();
    const isNarrow = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const isTop = layout === 'top';

    // below md the sidebar is always in charge, so the choice is moot
    if (isNarrow) { return null; }

    return (
        <Tooltip title={isTop ? 'Switch to side menu' : 'Switch to top menu'}>
            <IconButton
                color="inherit"
                aria-label="toggle menu position"
                onClick={() => dispatch(changeMenuLayout(isTop ? 'side' : 'top'))}
            >
                {isTop ? <VerticalSplitIcon /> : <HorizontalSplitIcon />}
            </IconButton>
        </Tooltip>
    );
};

const CustomAppBar = props => {
    const classes = useStyles();
    const history = useHistory();

    const handleGoHome = () => {
        history.push('/');
    };

    return (
        <AppBar {...props} userMenu={<CustomUserMenu />}>
            <Toolbar>
                <IconButton
                    color="inherit"
                    onClick={handleGoHome}

                    sx={{ mr: 2 }}
                >
                    <HomeIcon />
                </IconButton>
            </Toolbar>
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            />
            <Logo />
            <span className={classes.spacer} />
            <MenuLayoutToggle />
            <ThemeToggle />
        </AppBar>
    );
};

export default CustomAppBar;